import Vue from 'vue'
import VueRouter from 'vue-router'
import { publicRoute, protectedRoute } from './config'
import store from '@/store'
import Config from '@/config.json'
import extendedConfig from '../tenants.js'

Vue.use(VueRouter)

const routes = publicRoute.concat(protectedRoute)

const router = new VueRouter({
  mode: 'history',
  base: Config.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    clearTimeout(store.state.libraryStates.reloadTimeout)
    clearTimeout(store.state.libraryStates.reloadProcessingTimeout)
    clearTimeout(store.state.patientsStates.reloadJournalTimeout)
    store.state.appStates.viewRequiresAuth = true
    store.state.libraryStates.savedDirectory = false
    if (!store.state.userStates.loggedIn || !store.state.userStates.token) {
      next({
        path: '/',
        params: { nextUrl: to.fullPath },
      })
    } else next()
  } else if (to.path === '/') {
    store.state.appStates.viewRequiresAuth = true
    next()
  } else {
    store.state.appStates.viewRequiresAuth = false
    next()
  }
})

const DEFAULT_TITLE = extendedConfig.VUE_MAIN_TITLE
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    const newTitle = to?.meta?.title
      ? `${to.meta.title} - ${to?.meta?.rootTitle || DEFAULT_TITLE}`
      : to?.meta?.rootTitle || DEFAULT_TITLE

    document.title = newTitle

    if (to?.meta?.favicon) {
      let faviconLink = document.querySelector("link[rel~='icon']")
      if (!faviconLink) {
        faviconLink = document.createElement('link')
        faviconLink.rel = 'icon'
        document.head.appendChild(faviconLink)
      }
      faviconLink.href = to.meta.favicon
    }

    const metas = Array.from(document.getElementsByTagName('meta'))
    const metaTitle = metas.find(m => m.attributes[0].nodeValue === 'og:title')
    const metaUrl = metas.find(m => m.attributes[0].nodeValue === 'og:url')
    if (metaTitle) {
      metaTitle.attributes[1].nodeValue = newTitle
    }
    if (metaUrl) {
      metaUrl.attributes[1].nodeValue =
        window.location.origin + window.location.pathname
    }
  })
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'pageview',
    pageTitle: to.name,
    pagePath: to.fullPath,
    pageLocation: to.fullPath,
    sendTo: Config.VUE_APP_GA_KEY,
  })
})

export default router
